import React, { useEffect, useState } from "react";
import { Button } from "@kui-react/button";
function ItemProductPanel({ item,locale,currency, theme,etailCall,setOpenRetailDetail ,setRetailProductObject,setRetailProductTitle}) {

  const brandstore = document.getElementById("nvidia_brandstore_widget");
  const brandstoreId = atob(brandstore.getAttribute("data-brandstore-id"));
  let price = item.productPrice.replace("$", "")?.split(".");
  // Function for sorting the product specification
  // eslint-disable-next-line
  const [data, setData] = useState([]);
  const customSortOrder = {
    "GPU": [
      "gpu",
      "gpu_memory_type",
      "gpu_boost_clock_speed",
      "cooling_system"],
    "LAPTOP": [
      "screen_size",
      "gpu",
      "processor",
      "ram",
      "hdd_size"
    ],
    "DESKTOP": [
      "gpu",
      "processor",
      "ram",
      "hdd_size",
      "cooling_system"
    ],
    "STUDIO_DESKTOP": [
      "gpu",
      "processor",
      "ram",
      "hdd_size",
      "cooling_system"
    ],
    "MONITOR": [
      "screen_size",
      "monitor_type"
    ],
    "STUDIO-LAPTOP": [
      "gpu",
      "processor",
      "ram",
      "hdd_size",
      "screen_size"
    ],
    "SHIELD_ACCESSORIES": [
      "gpu",
      "processor",
      "ram",
      "hdd_size",
      "screen_size"
    ]
  };
  const compareCustomOrder = (a, b) => {
    const aIndex = customSortOrder[(item?.category).toUpperCase()].indexOf(a.name);
    const bIndex = customSortOrder[(item?.category).toUpperCase()].indexOf(b.name);
    if (aIndex === -1) return 1;
    if (bIndex === -1) return -1;
    return aIndex - bIndex;
  };
  const onproductClick = (item) =>{
  
    if (item.retailers.length === 1 && item.retailers[0]?.purchaseLink?.includes('store.nvidia.com')) {
      const purchaseLink = item.retailers[0].purchaseLink;
      window.open(purchaseLink, '_blank');
      return
  }
    else{
      setOpenRetailDetail(true);
      setRetailProductObject(item.retailers);
      setRetailProductTitle(item.productTitle)
    }
  }

  useEffect(() => {
    if(item?.productInfo)setData(item?.productInfo.sort(compareCustomOrder));
    // eslint-disable-next-line
  }, [item]);

  return (
    <div
      span={3}
      key={item.id}
      className="nv-col-3 nv-border-right-bottom"
    >
      <div className="image-wrapper">
        <a
          href={item?.retailers[0]?.directPurchaseLink ? item?.retailers[0]?.directPurchaseLink : item?.productUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => { etailCall("PDP_CLICK", item.productUrl);onproductClick(item) }}>
          <img
            className={"card-img-top" + (theme === "dark" ? " overlay " : "")}
            src={item.imageURL}
            alt={item.productTitle + "image"}
            loading="lazy"
          /></a>
      </div>
      <div className="card-body">
        <div className="custom-tooltip">
          <a className="nv-card-title"
            href={item?.retailers[0]?.directPurchaseLink ? item?.retailers[0]?.directPurchaseLink : item?.productUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => { etailCall("PDP_CLICK", item.productUrl);onproductClick(item) }}>
            {item.productTitle}

          </a>
        </div>

        <div className="fullRow priceDiv">
          <div className="nV_main-info">
            <div className="nV_priceOne">

              <div className="nV_compareBlock">
              </div></div>
            <div className="nV_priceTwo">
              <div className="nV_moreinfo-section">
                {brandstoreId === '308' ? <div className="nV_emstock"><span>{item?.offerText}</span> DE DESCONTO NO BOLETO</div> : null}
                {brandstoreId === '22' || brandstoreId === '345' ? <div className="nV_emstock">Disponibles:<span>{item?.availability}</span>pzs.</div> : null}
              </div> </div></div></div>

              <div className="fullRow priceDiv">
          <div className="nV_main-info">
            <div className="nV_priceTwo">
              <div className="nV_moreinfo-section">
                <div className="emproduct_price">

                  <label className="nV_price">
                    {/* {brandstoreId === '397' ? currency + price[0] : currencyConvertor(item.productPrice)} */}
                    {currency +price[0]}.<span className="nv-after-digit-price">{price[1]}</span>
                    </label>
                </div>
              </div>
            </div>
          </div></div>

        <Button
          className="nv-btn-availability"
          href={item?.retailers[0]?.directPurchaseLink ? item?.retailers[0]?.directPurchaseLink : item?.productUrl}
          target="_blank"
          onClick={() => {etailCall("BUY_NOW", item.productUrl);onproductClick(item)}}
        >
          {/* {item?.productAvailable ? buttonText : ViewDetails} */}
          {/* {buttonText} */}
          Buy Now
        </Button>
      </div>
    </div>
  );
}

export default ItemProductPanel;
